import { Language } from './constants';
import { getLanguageFromLocalStorage } from './helpers';

const i19nConfig = {
  sv: {
    'Continue': 'Fortsätt',
    'Exercise': 'Övning',
    'Control questions': 'Kontrollfrågor',
    'Video': 'Video',
    'Lesson': 'Lektion',
    'Read me': 'Läs mig',
    'Start': 'Starta',
    'Instructions for Control Questions': 'Instruktioner till Kontrollfrågor',
    'Click on TRUE if you think the statement is true. If you think the statement is false, click on FALSE.': 'Klicka på RÄTT om du anser att påståendet är rätt. Om du tror att påståendet är fel, klickar du på FEL.',
    'Instructions for the questions': 'Instruktioner till frågorna',
    'Instructions': 'Instruktioner',
    'You have passed this entire lesson!': 'Du har klarat hela den här lektionen!',
    'Back to topic overview': 'Tillbaka till ämnesöversikten',
    'You have completed this entire section!': 'Du har klarat hela den här delen!',
    'You have passed this exercise.': 'Du har klarat den här övningen',
    'Continue with': 'Fortsätt med',
    'Continue with the next exercise.': 'Fortsätt med nästa övning',
    'Good job!': 'Bra jobbat!',
    'Loading': 'Laddar',
    'Next exercise': 'Nästa övning',
    'Next course': 'Nästa kurs',
    'True': 'Sant',
    'False': 'Falsk',
    "No": 'Nej',
    "Ok": 'Ok',
    "Wrong": 'Fel',
    "Right": 'Rätt',
    'Back': 'Tillbaka',
    'not': 'inte',
    'True or false?': 'Sant eller falskt?',
    'Pair words with phrases': 'Para ihop ord med fraser',
    'Choose the option that matches the text': 'Välj det alternativet som stämmer med texten.',
    'Finish the sentences': 'Fyll i meningarna',
    'Build sentences using words': 'Klicka på orden i rätt ordning',
    'Drag and drop words': 'Para ihop ord med bilder',
    'Pick the right object': 'Klicka på rätt vägmärke',
    'Match the words': 'Para ihop orden',
    'Click on the right phrase': 'Klicka på rätt fras som stammer överens med bilden',
    'Click on the correct phrase that matches the picture': 'Klicka på rätt fras som stämmer överens med bilden',
    'Click on the word or phrase that best matches the text.': 'Klicka på det ord eller den fras som passar bäst ihop med texten',
    'Sort in the right order': 'Sortera i rätt ordning',
    'Pass this section by answering at least 3/4 correctly': 'Klara denna sektion genom att svara rätt på minst 3/4',
    'of': 'av',
    'off': 'av',
    'on': 'på',
    'questions answered': 'frågor besvarade',
    'Cancel the test': 'Avbryt provet',
    'Submit': 'Lämna in',
    'You have time left': 'Du har tid kvar',
    'You have unanswered questions': 'Du har obesvarade frågor',
    'Are you sure you want to submit the sample?': 'Är du säker att du vill lämna in provet?',
    'Cancel the test': 'Avbryt provet',
    'Are you sure you want to exit without submitting?': 'Är du säker på att du vill avsluta utan att lämna in?',
    'Time is up': 'Tiden är slut',
    'The time for the exam has now expired and will be submitted.': 'Nu har tiden för provet gått ut och kommer lämnas in.',
    'Oops, something went wrong.': 'Ouups, någonting gick fel.',
    'You passed the test': 'Du klarade testet',
    'You have failed the test': 'Du missade testet',
    'You got right': 'Du fick rätt',
    'Right in this category': 'Rätt i denna kategori',
    'Do the test again': 'Göra testet igen',
    'Click on the road sign you want information about': 'Klicka på det vägmärke du vill ha information',
    'Click on the correct road sign.': 'Klicka på rätt vägskylt.',
    'Question': 'Fråga',
    'DO NOT SHOW AGAIN': 'VISA INTE IGEN',
    'Points': 'Poäng',
    'You answered': 'Du svarade',
  },
};

export const i19n = (key) => {
  const lang = getLanguageFromLocalStorage();
  if (lang === Language.en) return key;
  return i19nConfig[lang][key];
};